//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "GlasgowComaScale",
  data() {
    return {
      defaultJson: {
        "To pain": "刺痛睁眼",
        "Best Motor Response": "运动反应",
        NoneMOTOR: "无",
        "Extension to pain": "疼痛后伸展",
        NoneVERB: "无",
        Motor: "运动反应",
        Verbal: "言语反应",
        "E {{ eye }}  V {{ verbal }}  M {{ motor }}":
          "睁眼 {{ eye }}  言语 {{ verbal }}  运动 {{ motor }}",
        Oriented: "定向正常",
        "Eye Opening": "睁眼反应",
        "Abnormal flexion to pain": "疼痛后异常屈曲",
        Eye: "睁眼反应",
        NoneEYE: "无",
        "Withdraws from pain": "疼痛后躲避",
        "Incomprehensible sounds": "无法理解的声音",
        "GCS %@": "GCS %@",
        Spontaneous: "自动睁眼",
        "Verbal Response": "言语反应",
        "Confused / disoriented": "语句费解 / 无法定向",
        "Localises pain": "可定位疼痛",
        "To speech": "呼唤睁眼",
        "Inappropriate words": "错乱的用词",
        "Obeys command": "遵嘱活动",
      },
      form: {
        eye: "",
        verbal: "",
        motor: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "1", name: "无" },
        { value: "2", name: "刺痛睁眼" },
        { value: "3", name: "呼唤睁眼" },
        { value: "4", name: "自动睁眼" },
      ],
      dataList2: [
        { value: "1", name: "无" },
        { value: "2", name: "无法理解的声音" },
        { value: "3", name: "错乱的用词" },
        { value: "4", name: "语句费解 / 无法定向" },
        { value: "5", name: "定向正常" },
      ],
      dataList3: [
        { value: "1", name: "无" },
        { value: "2", name: "疼痛后伸展" },
        { value: "3", name: "疼痛后异常屈曲" },
        { value: "4", name: "疼痛后躲避" },
        { value: "5", name: "可定位疼痛" },
        { value: "6", name: "遵嘱活动" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // 	eye + verbal + motor
        let result = form.eye + form.verbal + form.motor;
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/GlasgowComaScale.vue